module.exports = __webpack_public_path__ + "img/imgp8785.24b49d8c.jpg";